import React from "react";
import { createForm, type IFormProps } from "@formily/core";

export const useFormily = <T extends object>(options: IFormProps<T>) => {
  const formilyRef = React.useRef(createForm(options));
  return formilyRef.current;
};
